import { RHFTextField } from "@app/components";
import { Strings } from "@app/constants";
import { login } from "@app/modules/auth";
import { Button, Stack, Typography, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const Form = ({
  setVerification,
  methods,
  userInformation,
  isAuthenticated,
  setActiveStep,
  setGetCarValue,
}: any) => {
  const theme = useTheme();
  const { setValue } = methods;
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInformation) {
      setValue(
        "mobileInfo.name",
        `${userInformation.firstName} ${userInformation.lastName}` || ""
      );
      setValue("mobileInfo.emailAddress", userInformation.email || "");
      setValue("mobileInfo.phoneNumber", userInformation.phone || "");
    }
  }, [userInformation, setValue]);

  const handleClick = () => {
    if(isAuthenticated){
      setGetCarValue(true);
      setActiveStep(9);
    }else{
      const enteredNumber = methods.getValues("mobileInfo.phoneNumber")
      dispatch(login({phoneNumber: String(enteredNumber)}))
      setVerification(true);
    }
  };
  return (
    <>
      <Stack width={{ xs: "100%", sm: "50%" }} alignItems={"start"} pt={1}>
        <Typography textAlign={"start"}>
          {Strings.step.mobileInfo.name}
        </Typography>
        <RHFTextField
          name={"mobileInfo.name"}
          placeholder={Strings.step.mobileInfo.name}
          sx={{
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 1,
            backgroundColor: theme.palette.grey[100],
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
              backgroundColor: "transparent",
              boxShadow: "none",
            },
            "& .MuiInputBase-input": {
              padding: "12px 14px",
            },
          }}
        />
      </Stack>
      <Stack width={{ xs: "100%", sm: "50%" }} alignItems={"start"} pt={1}>
        <Typography textAlign={"start"}>
          {Strings.step.mobileInfo.email}
        </Typography>
        <RHFTextField
          name={"mobileInfo.emailAddress"}
          placeholder={Strings.step.mobileInfo.email}
          sx={{
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 1,
            backgroundColor: theme.palette.grey[100],
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
              backgroundColor: "transparent",
              boxShadow: "none",
            },
            "& .MuiInputBase-input": {
              padding: "12px 14px",
            },
          }}
        />
      </Stack>
      <Stack width={{ xs: "100%", sm: "50%" }} alignItems={"start"} pt={1}>
        <Typography textAlign={"start"}>
          {Strings.step.mobileInfo.phoneNumber}
        </Typography>
        <RHFTextField
          name={"mobileInfo.phoneNumber"}
          placeholder={Strings.step.mobileInfo.phoneNumber}
          sx={{
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 1,
            backgroundColor: theme.palette.grey[100],
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
              backgroundColor: "transparent",
              boxShadow: "none",
            },
            "& .MuiInputBase-input": {
              padding: "12px 14px",
            },
          }}
        />
      </Stack>
      <Button
        sx={{ width: { xs: "50%", sm: "25%" } }}
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {isAuthenticated ? Strings.button.next : Strings.button.getOTP}
      </Button>
    </>
  );
};
